import PropTypes from 'prop-types'
import React, { useState, useEffect, useCallback } from 'react'
import * as componenteErrorService from '../servicios/componenteErrorService'

const ComponenteError = (props) => {
  const [componenteError, setComponenteError] = useState([])
  const [tipoAlert, setTipoAlert] = useState('')

  const errorClass = useCallback((tipo) => {
    let tipoAlert

    if (tipo === 'I') {
      tipoAlert = 'alert alert-componente-error'
    } else if (tipo === 'W') {
      tipoAlert = 'alert alert-warning mr-auto ml-auto mt-3'
    } else if (tipo === 'E') {
      tipoAlert = 'alert alert-danger mr-auto ml-auto mt-3'
    } else if (tipo === 'S') {
      tipoAlert = 'alert alert-success mr-auto ml-auto mt-3'
    }

    setTipoAlert(tipoAlert)
    return tipoAlert
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      const { data: componenteError } = await componenteErrorService.BuscarTodos(
        props.tipo,
        props.idAviso
      )
      setComponenteError(componenteError)
      const type = componenteError.map((error) => error.tipo)
      const datoTipo = type[0]
      errorClass(datoTipo)
    }
    fetchData()
  }, [props.tipo, props.idAviso, errorClass])

  return (
    <div className="row item pd-20 pl-30 pr-30">
      <div className={tipoAlert}>
        {componenteError.map((error) => (
          <React.Fragment key={error.idAviso}>
            <h2 className="alert-heading">{error.titulo}</h2>
            <p className="f-size-17">{error.detalle}</p>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

ComponenteError.propTypes = {
  tipo: PropTypes.string.isRequired,
  idAviso: PropTypes.number.isRequired
}

export default ComponenteError
